import { AxiosInstance } from "axios"

export interface GetSuperAgentRequest {
  page: number
  size: number
  keyword?: string
}

export interface SuperAgentsData {
  role: string
  first_name: string
  last_name: string
  full_name: string
  email: string
  id: number
  user_id: number
  agency_name: string
}

export interface GetSuperAgentResponse {
  time: string
  apiStatus: string
  data: {
    content: SuperAgentsData[]
    pageable: {
      sort: {
        empty: boolean
        sorted: boolean
        unsorted: boolean
      }
      offset: number
      pageNumber: number
      pageSize: number
      paged: boolean
      unpaged: boolean
    }
    last: boolean
    totalPages: number
    totalElements: number
    number: number
    sort: {
      empty: boolean
      sorted: boolean
      unsorted: boolean
    }
    size: number
    first: boolean
    numberOfElements: number
    empty: boolean
  }
}

export function getSuperAgent(
  params: GetSuperAgentRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "get",
    url: "/agent/super/agents",
    params,
  }) as Promise<{ data: GetSuperAgentResponse }>
}
